import { SectionHeading } from './SectionHeading'

const career = [
  {
    period: '2023 — 現在',
    role: '最高技術責任者 (CTO)',
    org: '合同会社Frectas',
    body: '業務のDXやシステム開発、AIによる業務効率化に取り組む。技術選定からアーキテクチャ設計、実装、インフラ構築、開発体制づくりまでを統括する。'
  },
  {
    period: '2024 — 2026',
    role: '大学院 修士課程',
    org: '九州工業大学大学院（2025年度修了）',
    body: '情報セキュリティを専攻し、暗号資産や機械学習に関わる研究に取り組む。'
  },
  {
    period: '2019 — 2023',
    role: '学士課程',
    org: '九州工業大学 情報工学部',
    body: '情報セキュリティを学ぶ。在学中はアプリコンテストに数多く挑戦し、学生プロジェクト「Comet」を立ち上げた。Cometの活動が評価され、大学より特別賞を受賞した。'
  }
]

export const Career = () => {
  return (
    <section id="career" className="py-12 border-t border-ink-100">
      <SectionHeading number="05" title="経歴・学歴" />
      <ol className="space-y-8">
        {career.map(({ period, role, org, body }) => (
          <li
            key={`${period}-${org}`}
            className="grid gap-1 sm:grid-cols-[8rem_1fr] sm:gap-6"
          >
            <div className="font-mono text-xs tabular-nums tracking-wider text-ink-600 pt-[3px]">
              {period}
            </div>
            <div>
              <h3 className="text-lg font-semibold leading-relaxed text-ink-800">
                {role}
              </h3>
              <p className="mt-0.5 text-sm text-ink-500">{org}</p>
              <p className="mt-2 text-base leading-[1.9] text-ink-700">
                {body}
              </p>
            </div>
          </li>
        ))}
      </ol>
    </section>
  )
}
